import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { YomaDateFormatPipe } from '../../../pipes/yoma-date-format.pipe';
import { ResolvedTrackingLaneNode } from '../../../model/iTrackingLane';

@Component({
  selector: 'tracking-lane-line',
  standalone: true,
  imports: [CommonModule, YomaDateFormatPipe],
  templateUrl: './tracking-lane-line.component.html',
  styleUrl: './tracking-lane-line.component.scss'
})
export class TrackingLaneLineComponent {
  @Input({ required: true }) nodes!: ResolvedTrackingLaneNode[];
  @Input() cancelled = false;

  isPlanned(node: ResolvedTrackingLaneNode): boolean {
    return !node.asIsDate && !!node.toBeDate;
  }
}
